import Cookies from 'js-cookie';
import { Hash } from '../commonLib/Hash';
import { Marketing } from './marketing';
import { TopcoPartner } from './TopcoPartner';
import { UserInfoType } from '../user/types/UserSeesionType';
import _ from 'lodash';
import axios from 'axios';
import { sendGTMEvent } from '@next/third-parties/google';

export namespace GTM {
  export const ID = 'GTM-PZC3LF2P';
  export enum EVENT {
    PAGEVIEW = 'pageview', // 페이지뷰
    JOIN = 'joinComplete', // 가입완료
    LOGIN = 'loginComplete', // 로그인
    OPEN_JOIN_MODAL = 'openJoinModal', // 가입 모달 노출
    JOIN_BUTTON_CLICK = 'CompleteRegistration', // 가입 버튼 클릭
    PURCHASE = 'payComplete', // 결제완료
    PURCHACE_COMPLETE_MODAL = 'purchaseCompleteModal', // 결제완료모달 진입시
    VIEW_EPISODE = 'viewEpisode', // 회차 열람
    VIEW_EPISODELIST = 'viewEpisodeList', // 회차리스트 열람
    VIEW_CATEGORY = 'viewCategory', // 카테고리 페이지 열람
    VIEW_MAIN = 'viewMain', // 메인페이지 열람
    NO_VISITOR_ID = 'noVisitorid', // visitor id 없음
    CLICK_CONTINUE_EPI = 'clickContinueEpi', // 에피소드 이어보기 클릭
    PURCHASE_BUTTON_CLICK = 'InitiateCheckout', // 결제 버튼 클릭
  }
  interface ParamsType {
    eventModel: {
      event_id: string;
    };
    externalId: string;
    partnerCode: string; // 파트너 코드
    hashed_email: string;
    payCnt?: number;
    ecommerce?: {
      // 결제정보
      purchase?: {
        id?: string;
        value?: number | string;
        currency?: string;
        transaction_id?: number;
        count?: number;
      };
    };
    comic?: { comicId?: number; episodeId?: number };
    user?: {
      loginId?: string;
      userId?: number;
      method?: string; // 일반 가입 -> '일반회원가입', 파트너 코드 유입 -> p_id
    };
    category?: string; // 열람 카테고리
    productIds?: number[]; // 열람 카테고리 상위 만화
  }

  export const getEventId = (): string => {
    try {
      const { google_tag_manager }: any = window;
      if (!google_tag_manager) return '';
      const gtmData = google_tag_manager['GTM-PZC3LF2P'].dataLayer.get('gtm');
      const gtmStart = gtmData?.start ?? '';
      const gtmUniqueEventId = gtmData?.uniqueEventId ?? '';

      return gtmStart + '.' + gtmUniqueEventId;
    } catch (err) {
      return '';
    }
  };

  export const send = ({
    event,
    params,
    eventId,
    externalId,
    userInfo,
  }: {
    event: EVENT;
    params?: Marketing.SetParamsType; //custom parameter
    eventId: string; //facebook 중복값 제거 event id
    externalId: string; // facebooke external id
    userInfo: UserInfoType;
  }) => {
    const partnerCode = TopcoPartner.getter();

    const userId: number = params?.userId ?? userInfo.userId;
    const loginId: string = params?.loginId ?? userInfo.loginId;

    const hashed_email = Hash.getHash(loginId);
    const gtmParams: ParamsType = {
      eventModel: {
        event_id: eventId,
      },
      externalId,
      partnerCode,
      user: {
        loginId,
        userId,
      },
      hashed_email,
      ...params,
    };

    sendGTMEvent({
      event,
      ...gtmParams,
    });
  };
}

export namespace Facebook {
  export const FBP_KEY = '_fbp';
  export const FBC_KEY = '_fbc';
  export const ID = 1418530662899289;
  export const TOKEN =
    'EABSwCIbyXbYBO1WjG2Cr65GLWcW59pUKZBGoFYZAhI1eGvkuv2vjGTtlcQXSMkGW9ZAQevMJjTFOR0Bc4oxMjl9GlRfetAyNzZCysfjH9RYFE5Xrc5206MsAhSeCNLXZBrpjVm3NxR4ZBAd1svCA7GSnVoLbHZAR7J7mDXX7jAmYs0MN9XEXxxqGTVZC9WCjWGms8gZDZD';
  export const getFbcCookie = () => {
    return Cookies.get(Facebook.FBC_KEY) || '';
  };
  export const getFbpCookie = () => {
    return Cookies.get(Facebook.FBP_KEY) || '';
  };
  export const getFbcSSR = (context: any, fbclid: string): string => {
    if (!context) return '';
    const cookies = context.req.cookie ?? {};
    const fbcCookie = cookies[Facebook.FBC_KEY];

    // _fbc 쿠키 값에서 마지막 '.' 뒤의 문자열 가져오기
    if (fbcCookie) {
      const parts = fbcCookie.split('.');
      if (parts.length > 1) {
        const fbcCookieValue = parts[parts.length - 1];
        if (fbcCookieValue === fbclid) {
          return '';
        }
      }
    }
    const timestamp = Math.floor(Date.now() / 1000);
    return `fb.1.${timestamp}.${fbclid}`;
  };
  export const send = ({
    event,
    params,
    eventId,
    externalId,
    userInfo,
  }: {
    event: GTM.EVENT;
    params?: Marketing.SetParamsType; //custom parameter
    eventId: string; //facebook 중복값 제거 event id
    externalId: string; // facebooke external id
    userInfo: UserInfoType;
  }) => {
    if (!Facebook.getFbcCookie()) return;

    const config = getFbEventConfig(event, params);
    if (!config) return;

    const { customData, eventName } = config;

    sendApi({
      eventName,
      eventId,
      externalId,
      userInfo,
      customData,
    });
  };

  const sendApi = async ({
    eventName,
    eventId,
    externalId,
    customData,
    userInfo,
  }: {
    eventName: string;
    eventId: string;
    externalId: string;
    customData?: any;
    userInfo: UserInfoType;
  }) => {
    const ip = await getIp();
    const email = Hash.getHash(userInfo.loginId);
    const requestConfig: any = {
      method: 'POST',
      params: {
        access_token: Facebook.TOKEN,
      },
      url: `https://graph.facebook.com/v14.0/${Facebook.ID}/events`,
      data: {
        data: [
          {
            event_name: eventName,
            event_time: Math.floor(Date.now() / 1000),
            event_id: eventId,
            action_source: 'website',
            user_data: {
              external_id: externalId,
              fbp: getFbpCookie(),
              fbc: getFbcCookie(),
              em: email,
              client_ip_address: ip,
              client_user_agent:
                typeof window !== undefined ? window.navigator.userAgent : '',
            },
            custom_data: customData,
          },
        ],
      },
    };

    axios.request(requestConfig);
  };

  const getIp = async (): Promise<string> => {
    try {
      const data = await fetch('https://api64.ipify.org/?format=json');

      if (!data) return '';

      const json = await data.json();
      if (!json) return '';

      return json.ip;
    } catch (e) {
      console.warn('fbca error', e);
      return '';
    }
  };
  const getFbEventConfig = (
    event: GTM.EVENT,
    params?: Marketing.SetParamsType,
  ): { eventName: string; customData?: any } | null => {
    switch (event) {
      case GTM.EVENT.LOGIN:
        return { eventName: 'login' };
      case GTM.EVENT.JOIN:
        return { eventName: 'signup' };
      case GTM.EVENT.PURCHACE_COMPLETE_MODAL:
        return {
          eventName: 'purchase',
          customData: {
            currency: params?.purchase?.currency || 'USD',
            value: params?.purchase?.value || 1,
            order_id: params?.purchase?.transaction_id || '1',
          },
        };
      case GTM.EVENT.VIEW_EPISODELIST:
        return {
          eventName: 'readComic',
          customData: {
            comic: params?.comicId || 0,
          },
        };
      case GTM.EVENT.VIEW_EPISODE:
        return {
          eventName: 'readEpisode',
          customData: {
            episode: params?.episodeId || 0,
          },
        };
      default:
        return null;
    }
  };
}

export namespace Adsterra {
  export const PID_START = 'at';
  export const KEY = 'adt_clickId';
  const URL = 'https://www.pbterra.com/name/daycomics/at';
  const getCookie = () => {
    const clickId = Cookies.get(KEY) || '';
    clear();
    return clickId;
  };
  export const sendApi = async (event: GTM.EVENT): Promise<boolean> => {
    const value = getCookie();
    if (!value) return false;

    switch (event) {
      case GTM.EVENT.JOIN:
        try {
          fetch(`${URL}?subid_short=${value}`, {
            mode: 'no-cors',
          });
          return true;
        } catch (e: any) {
          return false;
        }
      default:
        return false;
    }
  };
  const clear = () => {
    Cookies.remove(KEY);
  };
}

export namespace Dv360 {
  export const KEY = 'dv_clickId';
  export const PID_START = 'dv';
  const URL = 'https://googleads.atelos.net/postback';
  const getCookie = () => {
    const value = Cookies.get(KEY) || '';
    return value;
  };
  export const sendApi = async (
    event: GTM.EVENT,
    params?: Marketing.SetParamsType,
  ): Promise<boolean> => {
    const value = getCookie();
    if (!value) return false;

    switch (event) {
      case GTM.EVENT.JOIN:
        try {
          fetch(
            `${URL}?cid=${value}&payout=OPTIONAL&currency=OPTIONAL&txid=OPTIONAL`,
            {
              mode: 'no-cors',
            },
          );
          return true;
        } catch (e: any) {
          return false;
        }
      case GTM.EVENT.PURCHACE_COMPLETE_MODAL:
        const currency = params?.purchase?.currency || 'USD';
        const payout = params?.purchase?.value || 1;
        const txid = params?.purchase?.transaction_id || '1';
        // payout : 주문금액 콤마 없이
        // txid : 주문번호
        try {
          fetch(
            `${URL}?cid=${value}&payout=${payout}&currency=${currency}&txid=${txid}`,
            {
              mode: 'no-cors',
            },
          );
          return true;
        } catch (e: any) {
          return false;
        }
      default:
        return false;
    }
  };
  const clear = () => {
    Cookies.remove(KEY);
  };
}

export namespace Tiktok {
  export const ID = 'D0L91HBC77UAQ078QFK0';
  export const NAME = 'TIKTOK API(2025)';
  export const TOKEN = '3335a982f443c048e58fb8d41c6383df70148480';
  export const KEY = 'tiktok_cId';
  export const PID_START = 'tiktok';
  const getCookie = () => {
    const value = Cookies.get(KEY) || '';
    return value;
  };
  export const sendApi = async (
    event: GTM.EVENT,
    params?: Marketing.SetParamsType,
  ): Promise<boolean> => {
    const value = getCookie();
    if (!value) return false;

    switch (event) {
      case GTM.EVENT.JOIN:
        try {
          const requestBody = {
            event_source: 'web',
            event_source_id: ID,
            data: [
              {
                event: 'CompleteRegistration',
                event_time: new Date().getTime(),
                event_id: 'CompleteRegistration',
                user: {
                  email: params?.loginId,
                  ttclid: value,
                  user_agent: navigator.userAgent,
                },
              },
            ],
          };

          fetch('/tiktok', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Access-Token': TOKEN,
            },
            body: JSON.stringify(requestBody),
          });
          return true;
        } catch (e: any) {
          return false;
        }
      default:
        return false;
    }
  };
}

export namespace Exo {
  export const KEY = 'exo_clickId';
  export const PID_START = 'exo';
  const URL = 'https://s.magsrv.com/tag.php';
  const getCookie = () => {
    const value = Cookies.get(KEY) || '';
    return value;
  };
  export const sendApi = async (
    event: GTM.EVENT,
    params?: Marketing.SetParamsType,
  ): Promise<boolean> => {
    const value = getCookie();
    if (!value) return false;

    switch (event) {
      case GTM.EVENT.JOIN:
        try {
          fetch(
            `${URL}?goal=4ea527525327cc38ed8fec0a6d030eb3cf1ba873&tag=${value}`,
            {
              mode: 'no-cors',
            },
          );
          return true;
        } catch (e: any) {
          return false;
        }
      default:
        return false;
    }
  };
  export const clear = () => {
    Cookies.remove(KEY);
  };
}

export namespace Assist {
  export const KEY = 'assist_clickId';
  export const PID_START = 'as';
  const URL = 'https://adserver.assistads.net/cv';
  const getCookie = () => {
    const value = Cookies.get(KEY) || '';
    return value;
  };
  export const sendApi = async (
    event: GTM.EVENT,
    params?: Marketing.SetParamsType,
  ): Promise<boolean> => {
    const value = getCookie();
    if (!value) return false;

    switch (event) {
      case GTM.EVENT.JOIN:
        try {
          fetch(`${URL}?assistclickid=${value}`, {
            mode: 'no-cors',
          });
          return true;
        } catch (e: any) {
          return false;
        }
      case GTM.EVENT.PURCHACE_COMPLETE_MODAL:
        try {
          fetch(`${URL}?assistclickid=${value}&cv_type=2`, {
            mode: 'no-cors',
          });
          return true;
        } catch (e: any) {
          return false;
        }
      default:
        return false;
    }
  };
  export const clear = () => {
    Cookies.remove(KEY);
  };
}

export namespace RedTrack {
  export const KEY = 'redtrack_clickId';
  export const PID_START = 'redtrack';
  export const P_TOKEN = 'qytjqrpvtn';
  const URL = 'https://n0onl.rttrk.com/postback';

  const getCookie = () => {
    const value = Cookies.get(KEY) || '';
    return value;
  };

  export const sendApi = async (event: GTM.EVENT): Promise<boolean> => {
    const value = getCookie();
    if (!value) return false;

    switch (event) {
      case GTM.EVENT.JOIN:
        try {
          fetch(`${URL}?ptoken=${P_TOKEN}&clickid=${value}`, {
            mode: 'no-cors',
          });
          return true;
        } catch (e: any) {
          return false;
        }
      default:
        return false;
    }
  };

  export const getPaymentParams = () => {
    const value = getCookie();
    if (!value) return null;
    return {
      clickid: value,
    };
  };

  export const clear = () => {
    Cookies.remove(KEY);
  };
}
